import { Toast as ToastType } from '../types';

interface ToastProps {
  toast: ToastType | null;
}

export function Toast({ toast }: ToastProps) {
  if (!toast) return null;

  return (
    <div 
      className="fixed bottom-8 left-1/2 transform -translate-x-1/2 px-6 py-3 rounded-lg shadow-lg z-50 transition-all"
      style={{
        background: toast.type === 'success' ? '#059669' : '#dc2626',
        color: 'white'
      }}
    >
      {toast.message}
    </div>
  );
}
